// extracted by mini-css-extract-plugin
export var alertIcon = "_nz-0";